import { LocalizedText } from '@mews/framework';
import { TextKey, ArticlePath, createGuideLink } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';
import { LocalizedLabel, NewTabLink } from '@mews-commander/ui';
import { Dialog, DialogPosition, Stack } from '@optimus-web/core';

interface TimelinePreviewDialogProps extends WithGuideLink {
    active: boolean;
    resourceMovementsCount: number;
    onCloseDialog(): void;
    onApplyOptimize(): void;
}

const TimelinePreviewDialog = ({
    active,
    resourceMovementsCount,
    onCloseDialog,
    onApplyOptimize,
}: TimelinePreviewDialogProps) => {
    const guideLink = createGuideLink(ArticlePath.OptimizeSpaceAllocation);
    const actions = [
        {
            onClick: onCloseDialog,
            children: <LocalizedText textKey={TextKey.GoBack} />,
            variant: 'ghost',
        },
        {
            onClick: onApplyOptimize,
            children: <LocalizedText textKey={TextKey.ApplyChanges} />,
            variant: 'primary',
        },
    ];
    const content = (
        <Stack vertical>
            <LocalizedLabel
                textKey={TextKey.SpaceAllocationResultMessage}
                substitutes={{ count: resourceMovementsCount }}
                as="div"
            />
            <div>
                <NewTabLink url={guideLink}>
                    <LocalizedText textKey={TextKey.LearnMoreAboutThisFeature} />
                </NewTabLink>
            </div>
        </Stack>
    );

    return (
        <Dialog
            active={active}
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            actions={actions}
            modal={false}
            size="medium"
            position={DialogPosition.Corner}
            title={<LocalizedText textKey={TextKey.ApplyChangesToSpaceAllocationQuestion} />}
        >
            {content}
        </Dialog>
    );
};

export default TimelinePreviewDialog;
